if (!window.__lBundleCartInit) {
  window.__lBundleCartInit = true;

  const cartUpdateUrl = () => (window.routes && window.routes.cart_update_url) || '/cart/update.js';
  const cartJsonUrl = '/cart.js';

  const publishUpdate = (cartData) => {
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'bundle-cart',
        cartData,
      });
    }
  };

  const fetchCart = () =>
    fetch(cartJsonUrl, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  let pruning = false;
  async function pruneOrphanBundles() {
    if (pruning) return;
    pruning = true;
    try {
      const cart = await fetchCart();
      const groups = {};
      cart.items.forEach((line, idx) => {
        const id = line.properties && line.properties._bundle_id;
        if (!id) return;
        const size = parseInt((line.properties && line.properties._bundle_size) || '0', 10);
        if (!groups[id]) groups[id] = { size, idxs: [] };
        groups[id].idxs.push(idx);
      });
      const updates = cart.items.map((i) => i.quantity);
      let dirty = false;
      for (const g of Object.values(groups)) {
        if (g.size > 0 && g.idxs.length < g.size) {
          g.idxs.forEach((i) => {
            updates[i] = 0;
          });
          dirty = true;
        }
      }
      if (!dirty) return;
      const res = await fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates }),
      });
      const updated = await res.json();
      publishUpdate(updated);
    } catch (err) {
      console.error('Bundle prune failed', err);
    } finally {
      pruning = false;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', pruneOrphanBundles, { once: true });
  } else {
    pruneOrphanBundles();
  }

  document.addEventListener('cart:refresh', pruneOrphanBundles);

  function lineKeysForGroup(groupId) {
    const keys = new Set();
    document.querySelectorAll('[data-bundle-line-key]').forEach((el) => {
      const owner = el.closest('[data-bundle-group]') || el;
      if (owner && owner.getAttribute('data-bundle-group') === groupId) {
        keys.add(el.dataset.bundleLineKey);
      }
    });
    return Array.from(keys);
  }

  function controlsForGroup(groupId) {
    return document.querySelectorAll(
      `[data-bundle-group="${CSS.escape(groupId)}"] [data-bundle-plus], [data-bundle-group="${CSS.escape(groupId)}"] [data-bundle-minus], [data-bundle-group="${CSS.escape(groupId)}"] [data-bundle-remove]`
    );
  }

  function setGroupLoading(groupId, on) {
    controlsForGroup(groupId).forEach((b) => {
      b.disabled = !!on;
    });

    document
      .querySelectorAll(`[data-bundle-group="${CSS.escape(groupId)}"] .loading__spinner`)
      .forEach((spinner) => spinner.classList.toggle('hidden', !on));

    const container = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    if (container) container.classList.toggle('cart__items--disabled', !!on);
  }

  function sectionInnerHTML(html, selector) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = selector ? doc.querySelector(selector) : doc;
    return el ? el.innerHTML : '';
  }

  function toggleEmptyState(isEmpty) {
    document
      .querySelectorAll('cart-drawer, cart-items, cart-drawer-items')
      .forEach((el) => el.classList.toggle('is-empty', isEmpty));
    const footer = document.getElementById('main-cart-footer');
    if (footer) footer.classList.toggle('is-empty', isEmpty);
  }

  async function bundleCartUpdate(groupEl, groupId, delta) {
    const keys = lineKeysForGroup(groupId);
    if (!keys.length) return;

    setGroupLoading(groupId, true);

    const inDrawer = !!groupEl.closest('cart-drawer');
    const cartTarget = inDrawer ? document.querySelector('cart-drawer') : null;
    const cartItemsEl = document.querySelector('cart-items');

    const sectionIds = new Set(['cart-icon-bubble']);
    if (cartTarget && typeof cartTarget.getSectionsToRender === 'function') {
      cartTarget.getSectionsToRender().forEach((s) => sectionIds.add(s.id));
    }
    if (cartItemsEl && typeof cartItemsEl.getSectionsToRender === 'function') {
      cartItemsEl.getSectionsToRender().forEach((s) => sectionIds.add(s.section));
    }

    try {
      const cart = await fetchCart();
      const updates = cart.items.map((item) => item.quantity);

      keys.forEach((key) => {
        const idx = cart.items.findIndex((item) => item.key === key);
        if (idx !== -1) {
          updates[idx] = delta === null ? 0 : Math.max(0, cart.items[idx].quantity + delta);
        }
      });

      const res = await fetch(cartUpdateUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: [...sectionIds], sections_url: window.location.pathname }),
      });
      const updated = await res.json();

      toggleEmptyState(updated.item_count === 0);

      if (cartTarget && typeof cartTarget.renderContents === 'function') {
        cartTarget.renderContents(updated);
      }

      if (cartItemsEl && updated.sections) {
        cartItemsEl.getSectionsToRender().forEach((section) => {
          const host = document.getElementById(section.id);
          if (!host || !updated.sections[section.section]) return;
          const target = host.querySelector(section.selector) || host;
          target.innerHTML = sectionInnerHTML(updated.sections[section.section], section.selector);
        });
      }

      // Notify other listeners (free-shipping bars, etc.) without triggering the
      // cart-items/cart-drawer-items auto re-render, which we've already done above.
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: updated });
      }
    } catch (err) {
      console.error('Bundle cart update failed', err);
      setGroupLoading(groupId, false);
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-bundle-plus],[data-bundle-minus],[data-bundle-remove]');
    if (!btn || btn.disabled) return;

    const group = btn.closest('[data-bundle-group]');
    if (!group) return;

    e.preventDefault();
    e.stopPropagation();

    const groupId = group.getAttribute('data-bundle-group');
    const delta = btn.hasAttribute('data-bundle-remove')
      ? null
      : btn.hasAttribute('data-bundle-plus')
      ? 1
      : -1;

    bundleCartUpdate(group, groupId, delta);
  });
}
